import React from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

import { Strings } from "@app/constants";
import { DropDownMenu } from "./dropDownMenu";

interface NavLink {
  label: string;
  onClick: () => void;
  path: string;
}
interface NavbarLinksProps {
  navLinks: NavLink[];
  sellCarOption: {
    label: string;
    value: string;
    onClick?: () => void;
  }[];
}

const NavbarLinks = ({ navLinks, sellCarOption }: NavbarLinksProps) => {
  const theme = useTheme();
  const { pathname } = useLocation();

  return (
    <Stack
      direction="row"
      spacing={4}
      sx={{
        width: { xs: "100%", md: "70%" },
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {navLinks?.map((link, index) =>
        link?.label === Strings.navBar.sellCars ? (
          <DropDownMenu value={link?.label} shortOptions={sellCarOption} />
        ) : (
          <Typography
            key={index}
            onClick={link?.onClick}
            sx={{
              position: "relative",
              color: theme.palette.primary.main,
              fontSize: { sm: 13, md: 15 },
              cursor: "pointer",
              textDecoration: pathname === link?.path ? "underline" : "none",
              textUnderlineOffset: "5px",

              "&::after": {
                content: '""',
                position: "absolute",
                left: "50%",
                bottom: 0,
                width: 0,
                height: "1px",
                backgroundColor: theme.palette.primary.main,
                transition: "all 0.3s ease",
                transform: "translateX(-50%)",
              },

              "&:hover::after": {
                width: "100%",
              },
            }}
          >
            {link?.label}
          </Typography>
        )
      )}
    </Stack>
  );
};

export { NavbarLinks };
